import React, { forwardRef, useEffect, useRef } from 'react';
import ReactAudio from 'react-h5-audio-player';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ContentBookPath, Mp3Path } from '../../../asset/utils/Constant';
import { setCurrentTime, setDurationTime, setPlay, setRange, setRewind } from '../../../store/TrackSlice';
import { Input } from '../../_atoms/Input';

const AudioPlayer = styled(ReactAudio)`
  width : 0;
  height : 0;
  opacity: 0;
  display: none;
`;

export const AudioProgressBar = forwardRef((props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  const player = useRef();

  useEffect(() => {
    // mp3 렌더링시 자동재생 되는 것 막기
    player.current.audio.current.pause();
    
    // 재생 / 일시정지
    state.track.play ? player.current.audio.current.play() : player.current.audio.current.pause();

    state.track.repeat ? player.current.audio.current.loop = true : player.current.audio.current.loop = false;
  }, [state.track.unit, state.track.track, state.track.play, state.track.repeat]);
  
  useEffect(() => {
    player.current.audio.current.addEventListener('timeupdate', onTimeUpdate);
  });

  const onTimeUpdate = () => {
    // 현재 재생 시간
    player.current && player.current.audio.current && dispatch(setCurrentTime(player.current.audio.current.currentTime));

    // progress bar
    player.current && dispatch(setRange((100 * parseInt(player.current.audio.current.currentTime)) / parseInt(player.current.audio.current.duration)));
  };

  const onTrackPlayEnd = () => {
    dispatch(setPlay(false));
    dispatch(setRewind(true));
    dispatch(setCurrentTime(0));

    // progress bar
    dispatch(setRange(0));
  };

  return (
    <>
      <AudioPlayer 
        ref={player}
        src={ContentBookPath + (state.book.current_book + 1) + Mp3Path + (state.track.unit + 1) + "_" + (state.track.track + 1) + '.mp3'}
        autoPlayAfterSrcChange={state.track.play}
        showSkipControls={true}
        showJumpControls={false}
        hasDefaultKeyBindings={false}
        preload="true"
        onEnded={onTrackPlayEnd}
        onLoadedMetaData={() => {
          dispatch(setDurationTime(player.current.audio.current.duration));
        }}
      />
      <Input
        type="range" 
        name="progress" 
        video={false}
        min={0}
        max={100}
        step={1}
        className={'progress'}
        value={isNaN(state.track.range) ? 0 : state.track.range}
        onChange={(e) => {
          dispatch(setRange(e.target.value));
          dispatch(setCurrentTime(parseInt(player.current.audio.current.duration * e.target.value / 100)));
          player.current.audio.current.currentTime = parseInt(player.current.audio.current.duration * e.target.value / 100);
        }}
        page={props.page}
      />
    </>
  );
});